import { Component, ChangeDetectionStrategy, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl, Validators } from '@angular/forms';
import { EQueryEscalationLevel, EscalationLevelName } from '../models/e-query-escalation-level';

interface EscalationLevelItem {
    readonly name: string;
    readonly value: EQueryEscalationLevel;
}

@Component({
    selector: 'escalation-level-select',
    template: require('./escalation-level-select.component.html'),
    styles: [require('./escalation-level-select.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EscalationLevelSelectComponent),
            multi: true
        }
    ]
})
export class EscalationLevelSelectComponent implements ControlValueAccessor {
    public readonly control = new FormControl(null, [Validators.required]);
    public onChange: (level: EQueryEscalationLevel) => void;
    public onTouch: () => void;
    public readonly levels = Object
        .keys(EQueryEscalationLevel)
        .filter(key => isNaN(Number(key)))
        .map<EscalationLevelItem>((key: EscalationLevelName) => ({ name: key, value: EQueryEscalationLevel[key] }));

    public writeValue(level: EQueryEscalationLevel): void {
        this.control.setValue(level);
    }

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    public setDisabledState?(isDisabled: boolean): void {
        if (isDisabled) {
            this.control.disable();
        } else {
            this.control.enable();
        }
    }

    public onSelectedLevel(level: EQueryEscalationLevel) {
        this.onChange(level);
        this.onTouch();
    }
}
